var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ButtonLink } from '@marketing/components/global/CTA/Button';
import Heading from '@marketing/components/global/typography/Heading';
import FlexSection from '@marketing/components/sections/FlexSection';
import { clsx } from 'clsx';
import Carousel from './Carousel';
function StartingFreshSection(_a) {
    var content = _a.content, _b = _a.backgroundColorStyle, backgroundColorStyle = _b === void 0 ? 'bg-surface-white' : _b;
    var steps = content.steps, ctaUrl = content.ctaUrl, buttonLabel = content.buttonLabel;
    var ButtonComponent = ctaUrl && buttonLabel ? (_jsx(ButtonLink, __assign({ href: ctaUrl, use: "secondary", size: "large", className: "w-full md:w-auto !min-w-[180px] md:!min-w-[192px]" }, { children: buttonLabel }))) : null;
    // a hack to give desktop a margin:auto on the left, but not on the right,
    // since cards need to be visible in the overflow of their container to the
    // far right edge, but be overflow:hidden to the left of their container,
    // so that the cards don't overlap the heading, etc.
    var desktopLeftMarginClassName = 'md:ml-[max(0px,(100vw-1440px)/2)]';
    return (_jsxs(FlexSection, __assign({ useMaxWidth: false, paddingStyle: "px-2xs-gutter py-lg-gutter md:pl-3xl-gutter md:pr-0 md:py-xl-gutter", className: clsx('md:!justify-start items-center', desktopLeftMarginClassName), gapStyle: "gap-xl-m md:gap-4xl-gutter", backgroundColorStyle: backgroundColorStyle }, { children: [_jsxs("div", __assign({ className: "flex flex-col gap-xl-m" }, { children: [_jsx(Heading, __assign({ size: "md", className: "text-center md:text-left" }, { children: "Starting Fresh" })), ButtonComponent && _jsx("div", __assign({ className: "hidden md:block" }, { children: ButtonComponent }))] })), _jsx("div", __assign({ className: "md:overflow-hidden flex-1 shrink-0" }, { children: _jsx(Carousel, { steps: steps }) })), ButtonComponent && _jsx("div", __assign({ className: "md:hidden" }, { children: ButtonComponent }))] })));
}
export default StartingFreshSection;
